module.exports = __webpack_public_path__ + "static/media/person.fdbc4613.svg";